import { supabase } from "./supabase";
import { googleOAuthOptions } from "./oauth-google-lib";
import { showFormError } from "./form-message-lib";

// Included on the homepage, /login/ and /register/ via the google-signin
// partial. Guarded so it is a no-op if the button is absent.
const button = document.getElementById("googleButton");
button?.addEventListener("click", () => {
  void (async () => {
    const { error } = await supabase.auth.signInWithOAuth(
      googleOAuthOptions(window.location.origin),
    );
    // On success supabase performs a top-level redirect to Google; we only get
    // here on failure to start the flow.
    if (error) {
      // Shown beside the button rather than in an alert, and without the
      // upstream wording -- which is written for whoever wrote the SDK.
      showFormError(
        button.parentElement ?? document.body,
        "Could not start Google sign-in. Please try again.",
        error,
      );
    }
  })();
});
